import {
  Component,
  Inject,
  NgZone,
  OnInit,
  ViewEncapsulation,
} from "@angular/core";
import * as moment from "moment";
import { NotifierService } from "../../shared/notifier/notifier.service";
import * as FileSaver from "file-saver";
import { DateAdapter, MAT_DIALOG_DATA, MatDialogRef } from "@angular/material";
import { PieceService } from "../../services/piece.service";

@Component({
  selector: "app-report-piece-dialog",
  templateUrl: "report-piece-dialog.component.html",
  styleUrls: ["./report-piece-dialog.components.scss"],
  encapsulation: ViewEncapsulation.None,
  providers: [PieceService],
})
export class ReportPieceDialogComponent implements OnInit {
  workOrderId: number = 0;

  fechaInicio: any;
  fechaFinal: any;

  constructor(
    public dialogRef: MatDialogRef<ReportPieceDialogComponent>,
    private notifierService: NotifierService,
    private pieceService: PieceService,
    private zone: NgZone,
    @Inject(MAT_DIALOG_DATA) public injected: any,
    private dateAdapter: DateAdapter<Date>
  ) {
    this.dateAdapter.setLocale("es-PE");

    if (this.injected) {
      if (this.injected.workOrderId) {
        this.workOrderId = this.injected.workOrderId;
      }
    }
  }

  ngOnInit() {}

  exportExcelPieceReport() {
    this.notifierService.systemNotify({
      title: "Descargando",
      message: "Descargando reporte de piezas",
      type: "info",
    });

    let fechaInicio: string | undefined = undefined;
    let fechaFinal: string | undefined = undefined;

    if (this.fechaInicio) {
       fechaInicio = moment(this.fechaInicio).format('YYYY-MM');
    }

    if (this.fechaFinal) {
       fechaFinal = moment(this.fechaFinal).format('YYYY-MM');  
    }

    let params = undefined;
    if (fechaInicio || fechaFinal) {
      params = {
        fechaInicio,
        fechaFinal
      }
    }

    this.pieceService.getExcelReport(this.workOrderId, params).subscribe(
      (result) => {
        let blob: any = result;
        let fileName = `report_piezas`;
        FileSaver.saveAs(blob, fileName);
        this.notifierService.systemNotify({
          title: "Descarga completada",
          message: "Reporte descargado correctamente",
          type: "success",
        });
      },
      (error) => {
        if (error.status == 400) {
          this.notifierService.systemNotify({
            title: "Error",
            message: "No se encontraron resultados para generar el reporte",
            type: "error",
          });
        } else {
          this.notifierService.systemNotify({
            title: "Error",
            message: "Sucedió un error al descargar el reporte",
            type: "error",
          });
        }
      }
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/system/work-order/report-piece-dialog/report-piece-dialog.component.ts